import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractCrudService } from '../service/abstract.crud.service';

@Injectable({
  providedIn: 'root'
})
export class PlanoSaudeService extends AbstractCrudService {

  protected getBaseUrlPrivate(): string {
    return super.getBaseUrlPrivate() + 'planosSaude';
  }

  protected getBaseUrlPublic(): string {
    return super.getBaseUrlPublic() + 'planosSaude';
  }

  listarPlanoSaudeFiltroInativoOuInterno(filtrarPLanoSaudeInativo: boolean, filtrarPlanoSaudeInterno: boolean): Observable<any> {
    return this.http.get(`${this.getBaseUrlPublic()}/filtroInativoOuInterno/${filtrarPLanoSaudeInativo}/${filtrarPlanoSaudeInterno}`);
  }

  listarPlanoSaudeFiltroInativoOuInternoSemRelacionamento(filtrarPLanoSaudeInativo: boolean, filtrarPlanoSaudeInterno: boolean): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/filtroInativoOuInterno/semRelacionamento/${filtrarPLanoSaudeInativo}/${filtrarPlanoSaudeInterno}`);
  }

  listarPlanoSaudeFiltroInativoOuInternoComProjecao(filtrarPLanoSaudeInativo: boolean, filtrarPlanoSaudeInterno: boolean): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/filtroInativoOuInterno/comProjecao/${filtrarPLanoSaudeInativo}/${filtrarPlanoSaudeInterno}`);
  }

  listarPlanoSaudeComRelacaoMinimaDeProcedimento(filtrarPLanoSaudeInativo: boolean, filtrarPlanoSaudeInterno: boolean): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/filtroInativoOuInterno/comRelacaoMinimaDeProcedimento/${filtrarPLanoSaudeInativo}/${filtrarPlanoSaudeInterno}`);
  }

  procurarPlanoSaudePorIdSemRelacionamento(entityId: number): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/semRelacionamento/${entityId}`);
  }

  atualizaRelacaoPlanoSaudeProcedimento(value: any): Observable<Object> {
    return this.http.put(`${this.getBaseUrlPrivate()}/relacaoPlanoSaudeProcedimento`, value);
  }

  listarPlanoSaudePorMedicoComProjecao(idMedico: number): Observable<any> {
    return this.http.get(`${this.getBaseUrlPrivate()}/comProjecao/medico/${idMedico}`);
  }

}
